exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info[data-v-6a34fbd9]{max-width:20em;width:100%;margin:2em}.between[data-v-6a34fbd9]{justify-content:space-between}.flex[data-v-6a34fbd9]{display:flex;align-items:center;justify-content:center}", ""]);

// exports
